import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKala = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={23} fill='currentColor' {...props}>
    <path
      fillRule='evenodd'
      d='M12.15 1.258c6.002 0 10.89 4.887 10.89 10.889S18.151 23 12.15 23C6.15 23 1.261 18.148 1.261 12.147c0-6.038 4.888-10.89 10.89-10.89m0 1.797a9.08 9.08 0 0 1 9.093 9.092 9.08 9.08 0 0 1-9.093 9.092 9.08 9.08 0 0 1-9.092-9.092c0-5.031 4.097-9.092 9.092-9.092'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='m12.15 0 4.205 3.09c-1.258-.61-2.695-.934-4.205-.934s-2.947.324-4.204.935zm7.26 5.319 4.204 3.09-1.545 4.816c.036-.36.072-.719.072-1.078 0-2.516-.934-4.852-2.516-6.577-.072-.107-.143-.18-.215-.251m1.401 11.715-1.581 4.924h-5.606a9.8 9.8 0 0 0 7.187-4.924m-10.134 4.924h-5.57l-1.618-4.924c1.51 2.624 4.133 4.493 7.188 4.924m-8.41-8.769L.722 8.41l4.205-3.09-.216.215a9.94 9.94 0 0 0-2.48 6.577c-.035.395 0 .755.036 1.078M6.185 9.81l3.88.935v1.042l-1.365-.36v2.121l1.366.323v1.007l-3.881-.935v-1.006l1.401.324v-2.085l-1.401-.323zM13.48 10.637l-3.414-.826v4.096l.934.216v-2.91l.719.179v2.91l1.078.252v-2.91l.719.179v2.911l.898.216v-3.235c-.036-.467-.43-.934-.934-1.078'
      clipRule='evenodd'
    />
    <path
      fillRule='evenodd'
      d='m14.378 9.81 4.313 1.043v1.222l-3.27-.755v.36l3.27.79v1.006l-3.27-.79v.395l3.27.755v1.15l-4.313-1.043z'
      clipRule='evenodd'
    />
  </svg>
);
export default SvgKala;
